import axiosInstance from './axios';
import axios from './axios';

const api = {
  /**
   * GET request with optional query params
   */
  get: (url, params = {}) =>
    axiosInstance.get(url, { params }),

  /**
   * POST request with JSON or FormData
   */
  post: (url, data) => {
    const headers = {};

    if (data instanceof FormData) {
      headers['Content-Type'] = 'multipart/form-data';
    }

    return axiosInstance.post(url, data, { headers });
  },

  /**
   * PUT request with JSON or FormData
   */
  put: (url, data) => {
    const headers = {};

    if (data instanceof FormData) {
      headers['Content-Type'] = 'multipart/form-data';
    }

    return axiosInstance.put(url, data, { headers });
  },

  /**
   * PATCH request
   */
  patch: (url, data) => axiosInstance.patch(url, data),

  /**
   * DELETE request (with optional data in body)
   */
  delete: (url, data = {}) =>
    axiosInstance.delete(url, { data }),
};

export default api;
